export default __webpack_public_path__ + "static/media/629-empty-box.473b0ccf.gif";